// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__25Vm0","colCheckbox":"styles_colCheckbox__5bTXw"};